import React from 'react'
import { connect } from 'react-redux'
import { array } from 'prop-types'
import GoHistory from 'react-icons/lib/go/history'
import TimeAgo from 'react-timeago'
import { withRouter } from 'react-router-dom'
import { addressBasedSearch } from '../../store/Actions/MapActions'
import { enableHistory } from '../../config'
import './styles/History.css'

const HistoryFilterItems = ({
  filterItems,
  history,
  radius,
  addressBasedSearch,
}) => (
  <div
    className="history-item"
    onClick={() => {
      addressBasedSearch(true)
      history.push(`${filterItems[0].url}/${radius}`)
    }}
  >
    <GoHistory color="green" />
    <strong>
      {filterItems[0].address.slice(0, 40)}
      ...
    </strong>{' '}
  </div>
)

const HistoryItems = ({ searchHistory, history, radius, addressBasedSearch }) =>
  searchHistory.map(search => (
    <div
      className="history-item"
      key={`${search.time}${search.url}`}
      onClick={() => {
        addressBasedSearch(true)
        history.push(`${search.url}/${radius}`)
      }}
    >
      <GoHistory color="black" />
      <small className="text-muted">
        {search.address.slice(0, 40)}
        ...
        <span className="timeago">
          <TimeAgo date={search.time} />
        </span>
      </small>
    </div>
  ))

const HistoryContainer = ({
  filteredSearchHistory,
  searchHistory,
  history,
  radius,
  addressBasedSearch,
}) => (
  <div className="history">
    <HistoryFilterItems
      filterItems={filteredSearchHistory}
      history={history}
      radius={radius}
      addressBasedSearch={addressBasedSearch}
    />
    <p className="history-title">History</p>
    <hr />
    <HistoryItems
      searchHistory={searchHistory}
      history={history}
      radius={radius}
      addressBasedSearch={addressBasedSearch}
    />
  </div>
)

const History = ({
  filteredSearchHistory,
  searchHistory,
  history,
  radius,
  addressBasedSearch,
}) =>
  filteredSearchHistory.length > 0 && enableHistory ? (
    <HistoryContainer
      filteredSearchHistory={filteredSearchHistory}
      searchHistory={searchHistory}
      history={history}
      radius={radius}
      addressBasedSearch={addressBasedSearch}
    />
  ) : null

const mapStateToProps = ({ signsState, spi, map }) => ({
  filteredSearchHistory: signsState.filterSearchHistory,
  searchHistory: spi.searchHistory,
  radius: map.radius,
})

History.propTypes = {
  filteredSearchHistory: array.isRequired,
  searchHistory: array.isRequired,
}

const actions = {
  addressBasedSearch,
}

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(History)
)



// WEBPACK FOOTER //
// ./src/components/History/index.jsx